module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isEdit),
            expression: "!isEdit"
          }],
          on: {
            "click": function($event) {
              return _vm.rollback()
            }
          }
        }, [_vm._v("Отменить выполнение")]), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isEdit),
            expression: "isEdit"
          }],
          on: {
            "click": _vm.ok
          }
        }, [_vm._v("ОК")])]
      },
      proxy: true
    }])
  }, [_c('v-card-text', [_c('v-flex', [_vm._v("\n        Действие планируется после заполнения даты и времени.\n        "), _c('div', [_vm._v("Внимание! Дата может заполняться автоматически.")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": "",
      "sm6": ""
    }
  }, [_c('v-date-field', {
    attrs: {
      "placeholder": "Сейчас",
      "value": _vm.scheduledDate,
      "readonly": !_vm.isEdit
    },
    on: {
      "input": _vm.onChangeDate
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "чч:мм",
      "mask": "##:##",
      "rules": [function (v) { return !v || /^(2[0-3]|[01]?[0-9])([0-5]?[0-9])$/.test(v) || 'чч:мм'; }],
      "readonly": !_vm.isEdit
    },
    model: {
      value: (_vm.scheduledTime),
      callback: function($$v) {
        _vm.scheduledTime = $$v
      },
      expression: "scheduledTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "rows": "3",
      "readonly": !_vm.isEdit
    },
    model: {
      value: (_vm.value && _vm.value.command),
      callback: function($$v) {
        _vm.$set(_vm.value && _vm.value, "command", $$v)
      },
      expression: "value && value.command"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aae763bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assist/fields/ActionForm.vue
// module id = 953
// module chunks = 1